var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"project-accounting-deal-create","title":"Deal erstellen","width":400}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('project-accounting-deal-form',{attrs:{"projectAccountingDeal":_vm.projectAccountingDeal,"type":"create"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }